















import Breadcrumb from "@/components/breadcrumb/Breadcrumb.vue";
import AlertComponent from "@/components/element/AlertComponent.vue";
import Footer from "@/components/footer/Footer.vue";
import VideoPlayer from "@/components/footer/VideoPlayer.vue";
import Header from "@/components/header/Header.vue";
import { DefineAbilityFor } from "@/config/ability";
import { CheckIsMUZE } from "@/helper/shareHelper";

const IsMUZE = CheckIsMUZE();
import { LoadingStatusType } from "@/enums/enums";
import { CreateIntercomHash } from "@/helper/intercomHelper";
import { MerchantId, UserId } from "@/helper/userHelper";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreLoading = namespace("Loading");
const StoreLogIn = namespace("LogIn");

@Component({
  components: {
    Header,
    Footer,
    VideoPlayer,
    Breadcrumb,
    AlertComponent,
  },
})
export default class Layout extends Vue {
  private renderPage = false;

  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel | null;
  @StoreLogIn.Getter
  private getSetSelectMerchantLoadingStatus!: LoadingStatusType;
  @StoreLogIn.Action
  private DoSelectMerchant!: (merchantId: number) => void;
  @StoreLoading.Action
  private IsLoading!: (isLoading: boolean) => void;
  @StoreLogIn.Action
  private ActivePayroll!: (merchantId: number) => void;

  mounted() {
    const userId = UserId();
    if (userId != 0 && !IsMUZE) {
      (this as any).$intercom.boot({
        /* eslint-disable @typescript-eslint/camelcase */
        user_id: userId,
        /* eslint-disable @typescript-eslint/camelcase */
        user_hash: CreateIntercomHash(userId),
      });
    }
  }

  created() {
    const waitingForPEAK = document.getElementById("waitingForPEAK");
    if (waitingForPEAK) {
      waitingForPEAK.style.display = "none";
    }
  }

  @Watch("$route.query.emi", { immediate: true })
  queryEmiChange() {
    let urlEmi: any = this.$route.query.emi;
    urlEmi = urlEmi ? urlEmi.PeakDecryption() : null;
    if (urlEmi) {
      this.DoSelectMerchant(urlEmi);
    } else {
      this.$router.push({ name: "selectList" });
    }
  }

  @Watch("getSetSelectMerchantLoadingStatus")
  getSetSelectMerchantLoadingStatusChange(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      if (this.getMerchant && this.getMerchant.merchantId && this.getMerchant.role.isUsePayroll) {
        if (!this.getMerchant.isActivePayroll) {
          this.ActivePayroll(this.getMerchant.merchantId);
        }
        if (this.getMerchant.merchantId !== MerchantId()) {
          sessionStorage.setItem("emi", this.getMerchant.merchantId.PeakEncryption());
        }
        if (!IsMUZE) {
          (this as any).$intercom.update({ company: { id: this.getMerchant.merchantId } });
        }

        const rules: any = DefineAbilityFor(this.getMerchant);
        this.$ability.update(rules);

        this.$nextTick(() => {
          if (this.getMerchant?.isActivePayroll) {
            this.renderPage = true;
          }
        });
      } else {
        this.$nextTick(() => {
          this.$router.push({ name: "canNotAccessMerchant" });
        });
      }
    }
  }

  @Watch("$i18n.locale", { deep: true })
  localeChanged(newVal: any, oldVal: any) {
    if (newVal != oldVal) {
      this.IsLoading(true);
      this.$router.go(0);
    }
  }
}
